module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\"><path d=\"M0 0h48v48h-48v-48z\" fill=\"none\"/><path d=\"M12 3.818c-5.455 0-10.113 3.393-12 8.182 1.887 4.789 6.545 8.182 12 8.182 5.46 0 10.111-3.394 12-8.182-1.889-4.789-6.54-8.182-12-8.182zm0 13.637c-3.011 0-5.455-2.444-5.455-5.455s2.444-5.455 5.455-5.455 5.455 2.444 5.455 5.455-2.444 5.455-5.455 5.455zm0-8.727c-1.807 0-3.271 1.467-3.271 3.273s1.467 3.272 3.271 3.272 3.273-1.467 3.273-3.272c0-1.806-1.466-3.273-3.273-3.273z\"/></svg>"


//////////////////
// WEBPACK FOOTER
// /home/runner/work/web-interactive/web-interactive/lib/images/icons/eye.svg
// module id = 795
// module chunks = 1